import { Route, Routes, useHref } from 'react-router-dom';

import { useOidcConfig } from '../hooks';
import { AuthedRedirect, PropsAuthedRedirect } from '../routes';
import { AuthGuard, PropsAuthGuard } from './AuthGuard';
import { LogoutRedirect } from './LogoutRedirect';

export type PropsAuthRoutes = {
  authRedirectPath?: string;
  postLogoutRedirectPath?: string;
  propsAuthGuard?: PropsAuthGuard;
  propsAuthedRedirect?: PropsAuthedRedirect;
} & Pick<PropsAuthGuard, 'renderComponent' | 'renderLoadingUI'>;

export function AuthRoutes({
  renderComponent,
  renderLoadingUI,
  propsAuthGuard,
  propsAuthedRedirect,
}: PropsAuthRoutes) {
  const originWithBase = `${window.location.origin}${useHref('')}`;
  const { redirect_uri, post_logout_redirect_uri } = useOidcConfig();

  function retrievePath(url: string) {
    return url.replace(originWithBase, '');
  }

  return (
    <Routes>
      <Route
        path={retrievePath(redirect_uri)}
        element={
          <AuthedRedirect
            renderLoadingUI={renderLoadingUI}
            {...propsAuthedRedirect}
          />
        }
      />
      {post_logout_redirect_uri !== undefined && (
        <Route
          path={retrievePath(post_logout_redirect_uri)}
          element={<LogoutRedirect />}
        />
      )}
      <Route
        path="*"
        element={
          <AuthGuard
            renderComponent={renderComponent}
            renderLoadingUI={renderLoadingUI}
            {...propsAuthGuard}
          />
        }
      />
    </Routes>
  );
}
